<template>
  <div class="upload-files">
    <el-upload
      ref="upload"
      action="#"
      :on-remove="handleRemove"
      :on-change="handleChange"
      :limit="maxFiles"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :auto-upload="false"
      :show-file-list="false"
      :before-upload="() => false"
      drag
      multiple
      class="upload-drop-zone"
    >
      <div class="upload-drop-content">
        <i class="el-icon-upload2 upload-icon"></i>
        <span class="upload-text"
          >Arrastra archivos aquí o <em>haz clic para seleccionar</em></span
        >
        <span class="upload-hint"
          >Máx. {{ maxFiles }} archivos, {{ maxSizeMB }}MB por archivo</span
        >
      </div>
    </el-upload>

    <div v-if="fileList.length" class="upload-file-list">
      <div
        v-for="(file, index) in fileList"
        :key="file.uid || index"
        class="upload-file-chip"
      >
        <i class="el-icon-document"></i>
        <span class="upload-file-name" :title="file.name">{{ file.name }}</span>
        <span class="upload-file-size">{{ formatSize(file.size) }}</span>
        <button
          type="button"
          class="upload-file-remove"
          @click="removeFile(index)"
          aria-label="Eliminar"
        >
          <i class="el-icon-close"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadFileComponent",
  props: {
    maxFiles: {
      type: Number,
      default: 5
    },
    maxSizeMB: {
      type: Number,
      default: 10
    },
    initialFiles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fileList: []
    };
  },
  created() {
    if (this.initialFiles && this.initialFiles.length) {
      this.fileList = [...this.initialFiles];
    }
  },
  methods: {
    handleChange(file, fileList) {
      const maxBytes = this.maxSizeMB * 1024 * 1024;
      if (file.raw && file.raw.size > maxBytes) {
        this.$notifications.warning({
          message: `"${file.name}" excede el límite de ${this.maxSizeMB}MB`
        });
        fileList.pop();
        this.fileList = [...fileList];
        return;
      }
      this.fileList = [...fileList];
      this.emitFiles();
    },
    handleRemove(file, fileList) {
      this.fileList = [...fileList];
      this.emitFiles();
    },
    handleExceed() {
      this.$notifications.warning({
        message: `Solo puedes adjuntar hasta ${this.maxFiles} archivos`
      });
    },
    removeFile(index) {
      this.fileList.splice(index, 1);
      this.emitFiles();
    },
    emitFiles() {
      this.$emit("uploadFile", { files: this.fileList });
    },
    formatSize(bytes) {
      if (!bytes) return "";
      if (bytes < 1024) return bytes + " B";
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + " KB";
      return (bytes / (1024 * 1024)).toFixed(1) + " MB";
    },
    reset() {
      this.fileList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-files {
  margin-top: 16px;
}

.upload-drop-zone {
  width: 100%;
}

.upload-drop-zone ::v-deep .el-upload {
  width: 100%;
}

.upload-drop-zone ::v-deep .el-upload-dragger {
  width: 100%;
  height: auto;
  padding: 20px 16px;
  border: 1.5px dashed #d4d7e5;
  border-radius: 10px;
  background: #fafbfc;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3ecfb4;
    background: #f0fdf9;
  }

  &.is-dragover {
    border-color: #3ecfb4;
    background: #e8fbf5;
  }
}

.upload-drop-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.upload-icon {
  font-size: 28px;
  color: #3ecfb4;
  line-height: 1;
}

.upload-text {
  font-size: 13px;
  color: #606266;
  em {
    color: #3ecfb4;
    font-style: normal;
    font-weight: 600;
  }
}

.upload-hint {
  font-size: 11px;
  color: #909399;
}

.upload-file-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
}

.upload-file-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #f4f5f9;
  border-radius: 8px;
  font-size: 13px;
  color: #31355c;
  transition: background 0.15s;

  &:hover {
    background: #ecedf3;
  }

  .el-icon-document {
    font-size: 15px;
    color: #909399;
    flex-shrink: 0;
  }
}

.upload-file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.upload-file-size {
  color: #909399;
  font-size: 11px;
  flex-shrink: 0;
}

.upload-file-remove {
  width: 22px;
  height: 22px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s;
  padding: 0;

  i {
    font-size: 12px;
    color: #909399;
  }

  &:hover {
    background: #e0e2ea;
    i {
      color: #f56c6c;
    }
  }
}
</style>
